export default "__VITE_ASSET__Cw6BoEig__"